import { Component, Input, OnChanges, OnDestroy, SimpleChange } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationMessageService } from '../../../services/validation-message.service';

@Component({
    selector: 'lf-control-messages',
    styleUrls: ['./control-messages.scss'],
    templateUrl: './control-messages.component.html',
})
export class ControlMessagesComponent implements OnChanges, OnDestroy
{
    @Input() control: AbstractControl;
    @Input() saved: boolean = false;
    @Input() errorsWhenPristine: boolean = false;
    @Input() displayError: boolean;
    @Input() successMessage: string = 'Updated successfully.';
    @Input() prefix = '';
    @Input() useConsolidatedMessage = false;

    errorMessage: string = null;

    private subscriptions: Subscription[] = null;

    constructor(private _validationMessageService: ValidationMessageService) {
    }

    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
        // This change event fires for the first time when the control is passed into the directive.
        if (changes.hasOwnProperty('control')) {
            const c: AbstractControl = changes['control'].currentValue;

            // Initialize change listener on form.
            if (this.subscriptions === null) {
                this.subscriptions = [
                    c.valueChanges.subscribe((value) => this.changeWatcher()),
                    c.statusChanges.subscribe((status) => this.changeWatcher()),
                ];

                this.changeWatcher();
            }
        }

        if (changes.hasOwnProperty('prefix')) {
            this.changeWatcher();
        }
    }

    ngOnDestroy() {
        for (const s in this.subscriptions) {
            if (this.subscriptions.hasOwnProperty(s) && typeof this.subscriptions[s].unsubscribe !== 'undefined') {
                this.subscriptions[s].unsubscribe();
            }
        }
        this.subscriptions = null;
    }

    public changeWatcher() {
        const messages: any[] = [];
        if (this.control && this.control.errors) {
            if (this.useConsolidatedMessage && (this.errorsWhenPristine || this.control.touched || !this.control.pristine)) {
                // Use for fields that have multiple errors to correct (password-hinter)
                messages.push('Please correct errors for this field.');
            } else {
                for (const p in this.control.errors) {
                    if (this.control.errors[p]) {
                        if (p === 'mask') {
                            continue;
                        }
                        if (this.control.errors.hasOwnProperty(p) && (this.errorsWhenPristine || this.control.touched || !this.control.pristine)) {
                            // Get the appropriate error message.
                            const msg: any = this._validationMessageService.getGenericErrorMessage(p, this.control.errors[p]);

                            if (!msg) {
                                if (this.control.errors[p] !== true && !(this.control.errors.hasOwnProperty('invalidPhoneFormat'))) {
                                    messages.push(this.prefix
                                            ? this.control.errors[p].replace('This field', this.prefix)
                                            : this.control.errors[p]);
                                }
                            } else {
                                if (!msg.requiredMask) {
                                    messages.push(this.prefix ? msg.replace('This field', this.prefix) : msg);
                                }
                            }
                        }
                    }
                }
            }
        }

        if (messages.length > 0) {
            this.errorMessage = messages.join('<br />');
        } else {
            this.errorMessage = null;
        }
    }
}
